import { RouteRecordRaw } from 'vue-router';
import { RouteConfig, UserRole, AppRouteMeta, RouteCategoryValue } from '../types';
import { commonRoutes } from './commonRoutes';
import { studentRoutes } from './studentRoutes';
import { employeeRoutes } from './employeeRoutes';

/**
 * Configuration des routes par rôle utilisateur
 */
export const roleBasedRoutes: RouteConfig[] = [
  {
    role: UserRole.STUDENT,
    homeRoute: '/student-home',
    routes: [...commonRoutes, ...studentRoutes],
  },
  {
    role: UserRole.COLLABORATEUR,
    homeRoute: '/employee-home',
    routes: [...commonRoutes, ...employeeRoutes],
  },
  {
    role: UserRole.ADMINISTRATOR,
    homeRoute: '/employee-home',
    routes: [...commonRoutes, ...employeeRoutes],
  },
];

/**
 * Toutes les routes de l'application combinées
 */
export const allRoutes: RouteRecordRaw[] = [...commonRoutes, ...studentRoutes, ...employeeRoutes];

/**
 * Obtient la route d'accueil pour un rôle donné
 */
export function getHomeRouteForRole(role: UserRole): string {
  const config = roleBasedRoutes.find((config) => config.role === role);
  return config?.homeRoute || '/';
}

/**
 * Obtient toutes les routes accessibles pour un rôle donné
 */
export function getRoutesForRole(role: UserRole): RouteRecordRaw[] {
  const config = roleBasedRoutes.find((config) => config.role === role);
  return config?.routes || commonRoutes;
}

/**
 * Filtre les routes par catégorie pour l'affichage dans les menus
 */
export function getRoutesByCategory(
  routes: RouteRecordRaw[],
  category: RouteCategoryValue
): RouteRecordRaw[] {
  return routes.filter(
    (route) =>
      (route.meta as AppRouteMeta)?.category === category &&
      !(route.meta as AppRouteMeta)?.hideInMenu &&
      route.name // Exclut les redirections
  );
}

/**
 * Vérifie si un utilisateur a accès à une route spécifique
 */
export function canAccessRoute(userRoles: string[], route: RouteRecordRaw): boolean {
  const meta = route.meta as AppRouteMeta;
  if (!meta?.requiresRole) {
    return true; // Route publique
  }

  return userRoles.includes(meta.requiresRole);
}
